import MuiAvatar from '@mui/material/Avatar';
import { Tooltip } from '@shared/components';
import { User } from '@shared/types/user';

const HAND_TUNED_NON_STANDARD_GRAY = 'rgb(206, 212, 220)';

type Sizes = 'medium' | 'small';

type AvatarProps = {
  size: Sizes;
  user: User;
  tooltipContent?: string;
};

export function Avatar({ size, user, tooltipContent }: AvatarProps) {
  return (
    <Tooltip content={tooltipContent}>
      <MuiAvatar
        sx={{
          width: toDimension(size),
          height: toDimension(size),
          fontSize: toFontSize(size),
          bgcolor: toBgColor(),
        }}
      >
        {toInitials(user)}
      </MuiAvatar>
    </Tooltip>
  );
}

function toInitials(user: User) {
  const nameLabel = userToNameLabel(user);
  if (!nameLabel) return '?';
  return nameLabel[0].toUpperCase();
}

function userToNameLabel(user: User): string | undefined {
  if (user.userProfile?.name) return user.userProfile.name;
  if (user.name) return user.name;
  if (user.userName) return user.userName;
  return;
}

function toDimension(size: Sizes) {
  switch (size) {
    case 'medium':
      return 24;
    case 'small':
      return 18;
  }
}

function toFontSize(size: Sizes) {
  switch (size) {
    case 'medium':
      return '12px';
    case 'small':
      return '10px';
  }
}

function toBgColor() {
  return HAND_TUNED_NON_STANDARD_GRAY;
}
